/* Cart redesign — behaviour shared by the drawer (snippets/cart-flyout.liquid)
   and the cart page (sections/main-cart-items.liquid).

   - Estimated delivery range ([data-c-cart-eta]) from business days.
   - Blower warning toggle + "Add + $X".
   - "<Item> removed  [Undo]" toast: snapshots a line just before any remove
     handler runs (window capture phase, ahead of the theme's own and the rush
     atomic-remove interceptors) and re-adds it on Undo.

   Vanilla JS on purpose: jQuery and cart-scripts load as type="lazyload2" and
   only start after the first interaction. */
(function () {
  if (window.cCart) return;

  var isCartPage = document.documentElement.getAttribute('data-c-cart-page') === 'true' ||
    /^\/cart\/?$/.test(window.location.pathname);

  /* ---------- delivery estimate ---------- */
  function addBusinessDays(date, days) {
    var d = new Date(date.getTime());
    var added = 0;
    while (added < days) {
      d.setDate(d.getDate() + 1);
      var wd = d.getDay();
      if (wd !== 0 && wd !== 6) added++;
    }
    return d;
  }
  function addCalendarDays(date, days) {
    var d = new Date(date.getTime());
    d.setDate(d.getDate() + days);
    return d;
  }
  function fmt(d) {
    return d.toLocaleDateString('en-US', { month: 'short', day: 'numeric' });
  }
  function renderEta(root) {
    (root || document).querySelectorAll('[data-c-cart-eta]').forEach(function (el) {
      var min = parseInt(el.getAttribute('data-min'), 10) || 0;
      var max = parseInt(el.getAttribute('data-max'), 10) || min;
      var now = new Date();
      // The delivery app counts calendar days from the order date.
      var add = el.getAttribute('data-days') === 'calendar' ? addCalendarDays : addBusinessDays;
      el.textContent = fmt(add(now, min)) + ' - ' + fmt(add(now, max));
    });
  }

  // Figma: the warning is expanded on desktop, collapsed on phones.
  function openWarningsOnDesktop(root) {
    if (!window.matchMedia || !window.matchMedia('(min-width: 750px)').matches) return;
    (root || document).querySelectorAll('[data-c-cart-warning]:not([data-touched]):not(.is-open)').forEach(function (box) {
      box.classList.add('is-open');
      var h = box.querySelector('[data-c-cart-warning-toggle]');
      if (h) h.setAttribute('aria-expanded', 'true');
    });
  }

  /* ---------- re-render helpers ---------- */
  function refreshCart() {
    if (isCartPage) { window.location.reload(); return; }
    if (typeof window.cart_slide_update === 'function') {
      try { window.cart_slide_update(); return; } catch (_) {}
    }
    window.location.reload();
  }

  function post(url, body) {
    return fetch(url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      credentials: 'same-origin',
      body: JSON.stringify(body)
    }).then(function (r) {
      if (!r.ok) return r.json().then(function (j) { throw new Error(j.description || j.message || r.status); });
      return r.json();
    });
  }

  /* ---------- toast ---------- */
  var toastTimer = null;
  var lastRemoved = null;

  function toastEl() {
    var scope = isCartPage ? document.querySelector('[data-c-cart-page-root]') : document.querySelector('.cart-sidebar');
    if (!scope) scope = document.body;
    var el = scope.querySelector(':scope > .c-cart-toast') || document.querySelector('.c-cart-toast[data-owner="' + (isCartPage ? 'page' : 'drawer') + '"]');
    if (!el) {
      el = document.createElement('div');
      el.className = 'c-cart-toast';
      el.setAttribute('data-owner', isCartPage ? 'page' : 'drawer');
      el.setAttribute('role', 'status');
      el.setAttribute('aria-live', 'polite');
      el.innerHTML =
        '<span class="c-cart-toast__text"></span>' +
        '<button type="button" class="c-cart-toast__undo" data-c-cart-undo>Undo</button>' +
        '<button type="button" class="c-cart-toast__close" data-c-cart-toast-close aria-label="Dismiss">' +
        '<svg width="12" height="12" viewBox="0 0 12 12" aria-hidden="true"><path d="M1 1l10 10M11 1 1 11" stroke="currentColor" stroke-width="1.4" stroke-linecap="round"/></svg>' +
        '</button>';
      scope.appendChild(el);
    }
    return el;
  }

  function placeToast(el) {
    if (isCartPage) return; // fixed via CSS on the page
    var anchor = document.querySelector('.cart-sidebar .c-cart__checkout');
    var side = document.querySelector('.cart-sidebar');
    if (!anchor || !side) return;
    var bottom = side.getBoundingClientRect().bottom - anchor.getBoundingClientRect().top + 8;
    el.style.bottom = Math.max(bottom, 8) + 'px';
  }

  function showToast(name) {
    var el = toastEl();
    el.querySelector('.c-cart-toast__text').textContent = name + ' removed';
    el.querySelector('[data-c-cart-undo]').disabled = false;
    el.classList.add('is-visible');
    // the drawer re-renders after a remove; place once it has settled
    placeToast(el);
    setTimeout(function () { placeToast(el); }, 400);
    clearTimeout(toastTimer);
    toastTimer = setTimeout(hideToast, 8000);
  }

  function hideToast() {
    try { sessionStorage.removeItem('cCartUndo'); } catch (_) {}
    var el = document.querySelector('.c-cart-toast.is-visible');
    if (el) el.classList.remove('is-visible');
  }

  function lineData(li) {
    var variantId = parseInt(li.getAttribute('data-variant-id'), 10);
    if (!variantId) return null;
    var qtyInput = li.querySelector('.cart-prod-qty, input[name="updates[]"], .quantity__input');
    var qty = parseInt(qtyInput ? qtyInput.value : li.getAttribute('data-quantity'), 10) || 1;
    var props = {};
    var raw = li.getAttribute('data-line-props');
    if (raw) {
      try {
        var parsed = JSON.parse(raw);
        if (Array.isArray(parsed)) parsed.forEach(function (p) { if (p && p.length >= 2) props[p[0]] = p[1]; });
        else if (parsed && typeof parsed === 'object') props = parsed;
      } catch (_) {}
    }
    var item = { id: variantId, quantity: qty };
    if (Object.keys(props).length) item.properties = props;
    var plan = li.getAttribute('data-selling-plan');
    if (plan) item.selling_plan = parseInt(plan, 10);
    return item;
  }

  /* Everything a remove takes with it, so Undo can put it all back:
     - fee lines (rush / digital proof) paired by data-fee-for — the rush atomic
       remove and the reconcile drop them with the parent;
     - _gwp siblings — cart-scripts removes them together;
     - nested children (parent_relationship) — Shopify removes them with the
       parent; they are re-added with parent_line_key. */
  function snapshot(li) {
    if (!li) return null;
    var main = lineData(li);
    if (!main) return null;
    var scope = li.closest('.cart-sidebar, [data-c-cart-page-root]') || document;
    var key = li.getAttribute('data-itemid');
    var removingFee = !!li.getAttribute('data-fee-for');
    var ids = [li.getAttribute('data-project-id'), li.getAttribute('data-rush-group'), key]
      .filter(function (v) { return v; });
    var gwp = li.getAttribute('data-gwp');
    var withParent = [];
    var children = [];
    scope.querySelectorAll('[data-c-cart-line]').forEach(function (other) {
      if (other === li) return;
      var d;
      if (!removingFee && ids.indexOf(other.getAttribute('data-fee-for')) !== -1) {
        d = lineData(other); if (d) withParent.push(d);
      } else if (gwp && other.getAttribute('data-gwp') === gwp) {
        d = lineData(other); if (d) withParent.push(d);
      } else if (key && other.getAttribute('data-parent-key') === key) {
        d = lineData(other); if (d) children.push(d);
      }
    });
    return {
      items: [main].concat(withParent),
      children: children,
      name: li.getAttribute('data-short-title') || li.getAttribute('data-fee-label') || 'Item'
    };
  }

  function restore(snap) {
    // Parent first so the fee lines' _rush_for / _proof_for still find it.
    return post('/cart/add.js', { items: snap.items }).then(function (res) {
      if (!snap.children || !snap.children.length) return res;
      var parent = res && res.items && res.items.filter(function (it) { return it.variant_id === snap.items[0].id; })[0];
      if (!parent) return res;
      return post('/cart/add.js', {
        items: snap.children.map(function (c) { c.parent_line_key = parent.key; return c; })
      });
    });
  }

  /* ---------- events ---------- */
  // Capture on window: runs before the document-capture rush interceptor and
  // the theme's jQuery handlers, so the line is still in the DOM.
  window.addEventListener('click', function (e) {
    var t = e.target;
    if (!t.closest) return;
    var rm = t.closest('.delete-cart-item, [data-c-cart-remove]');
    if (!rm) return;
    var li = rm.closest('.cart-item, [data-c-cart-line]');
    var snap = snapshot(li);
    if (!snap) return;
    lastRemoved = snap;
    // The cart page reloads after a remove; carry the snapshot across it.
    if (isCartPage) {
      try { sessionStorage.setItem('cCartUndo', JSON.stringify({ at: Date.now(), snap: snap })); } catch (_) {}
    }
    // Let the remove request go first; show the toast right after.
    setTimeout(function () { showToast(snap.name); }, 50);
  }, true);

  document.addEventListener('click', function (e) {
    var t = e.target;
    if (!t.closest) return;

    var toggle = t.closest('[data-c-cart-warning-toggle]');
    if (toggle) {
      e.preventDefault();
      var box = toggle.closest('[data-c-cart-warning]');
      var open = !box.classList.contains('is-open');
      box.classList.toggle('is-open', open);
      box.setAttribute('data-touched', '');
      toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
      return;
    }

    var add = t.closest('[data-c-cart-add-blower]');
    if (add) {
      e.preventDefault();
      if (add.disabled) return;
      add.disabled = true;
      add.classList.add('is-loading');
      post('/cart/add.js', { items: [{ id: parseInt(add.getAttribute('data-variant-id'), 10), quantity: parseInt(add.getAttribute('data-quantity'), 10) || 1 }] })
        .then(refreshCart)
        .catch(function (err) {
          console.warn('[c-cart] add blower', err);
          add.disabled = false;
          add.classList.remove('is-loading');
        });
      return;
    }

    if (t.closest('[data-c-cart-undo]')) {
      e.preventDefault();
      var btn = t.closest('[data-c-cart-undo]');
      if (!lastRemoved || btn.disabled) return;
      btn.disabled = true;
      restore(lastRemoved)
        .then(function () { lastRemoved = null; hideToast(); refreshCart(); })
        .catch(function (err) { console.warn('[c-cart] undo', err); btn.disabled = false; });
      return;
    }

    if (t.closest('[data-c-cart-toast-close]')) {
      e.preventDefault();
      lastRemoved = null;
      hideToast();
    }
  });

  /* ---------- wallet buttons in the drawer ----------
     Shopify only injects the portable-wallets module on /cart. Everywhere else
     it ships a Shopify.PaymentButton.init() stub that snippets/lazy-header.liquid
     breaks (its src= → rdata-src= rewrite turns `t.src=` into invalid JS), so the
     drawer's Shop Pay / Google Pay stay as grey skeletons. Load the module
     ourselves the first time the drawer opens with buttons in it. Scoped to the
     drawer on purpose: fixing lazy-header would switch on every PDP's
     dynamic-checkout setting site-wide. */
  var walletsRequested = false;
  function walletsUrl() {
    var found = null;
    document.querySelectorAll('script:not([src])').forEach(function (sc) {
      if (found) return;
      var m = (sc.textContent || '').match(/https?:\/\/[^"']+\/portable-wallets\/[^"']+\.js/);
      if (m) found = m[0];
    });
    return found || (window.location.origin + '/cdn/shopifycloud/portable-wallets/latest/portable-wallets.en.js');
  }
  function loadDrawerWallets() {
    if (walletsRequested || isCartPage) return;
    if (!document.querySelector('.c-cart-drawer shopify-accelerated-checkout-cart')) return;
    if (window.customElements && window.customElements.get('shopify-accelerated-checkout-cart') &&
        !document.querySelector('.c-cart-drawer .wallet-cart-grid--skeleton')) return;
    walletsRequested = true;
    var sc = document.createElement('script');
    sc.type = 'module';
    sc.src = walletsUrl();
    sc.crossOrigin = 'anonymous';
    document.head.appendChild(sc);
  }

  /* ---------- re-render hooks ---------- */
  // qty changes and removes don't re-render the drawer header; recount the
  // lines the customer sees (fee + child lines render inside their parent).
  function syncDrawerCount(root) {
    var el = root.querySelector('[data-c-cart-count]');
    if (!el) return;
    var n = 0;
    root.querySelectorAll('.shopping-cart-items > [data-c-cart-line]').forEach(function (li) {
      if (li.getAttribute('data-fee-for') || li.getAttribute('data-parent-connected') === 'true') return;
      if (li.classList.contains('hidden') || li.style.display === 'none' || li.style.opacity === '0') return;
      var q = li.querySelector('.cart-prod-qty');
      n += parseInt(q ? q.value : li.getAttribute('data-quantity'), 10) || 0;
    });
    var txt = n ? '(' + n + (n === 1 ? ' item)' : ' items)') : '';
    if (el.textContent !== txt) el.textContent = txt;
  }

  function watchDrawer() {
    var root = document.querySelector('.cart-sidebar');
    if (!root) return;
    var t = null;
    var legacyRefreshAt = 0;
    new MutationObserver(function () {
      clearTimeout(t);
      t = setTimeout(function () {
        renderEta(root);
        openWarningsOnDesktop(root);
        // the drawer often opens while its content is still being re-fetched;
        // try the wallets again once the new markup is in
        if (!root.classList.contains('closed')) loadDrawerWallets();
        syncDrawerCount(root);
        // cart_update() only rewrites .cart-subtotals; mirror it into the
        // checkout button.
        var sub = root.querySelector('.c-cart-drawer__subtotal .cart-subtotals');
        root.querySelectorAll('[data-c-cart-total]').forEach(function (el) {
          if (sub && el.textContent !== sub.textContent) el.textContent = sub.textContent;
        });
        // Several legacy PDP sections inject their own JS-templated rows into
        // .shopping-cart-items after add-to-cart. Swap them for the server
        // render once (throttled so it can't loop).
        var legacy = root.querySelector('.shopping-cart-items > li:not([data-c-cart-line])');
        if (legacy && typeof window.cart_slide_update === 'function' && Date.now() - legacyRefreshAt > 3000) {
          legacyRefreshAt = Date.now();
          try { window.cart_slide_update(); } catch (_) {}
        }
      }, 30);
    }).observe(root, { childList: true, subtree: true, characterData: true });
    // Load the wallet buttons the first time the drawer opens.
    new MutationObserver(function () {
      if (!root.classList.contains('closed')) loadDrawerWallets();
    }).observe(root, { attributes: true, attributeFilter: ['class'] });
  }

  function restoreUndo() {
    if (!isCartPage) return;
    try {
      var saved = JSON.parse(sessionStorage.getItem('cCartUndo') || 'null');
      if (saved && saved.snap && Date.now() - saved.at < 60000) {
        lastRemoved = saved.snap;
        showToast(saved.snap.name);
      } else {
        sessionStorage.removeItem('cCartUndo');
      }
    } catch (_) {}
  }

  // Rush/proof qty sync: cart-flyout.liquid reconciles 1.2s after a qty click,
  // which loses the race when the update itself takes longer. cart_update()
  // (cart-scripts.liquid) runs once the new quantities are committed, so
  // reconcile again from there. It only re-renders when something changed.
  function hookCartUpdate(tries) {
    if (typeof window.cart_update !== 'function') {
      if ((tries || 0) < 120) setTimeout(function () { hookCartUpdate((tries || 0) + 1); }, 500);
      return;
    }
    if (window.cart_update.__cCart) return;
    var orig = window.cart_update;
    var wrapped = function () {
      var r = orig.apply(this, arguments);
      // reconcile skips while another run is in flight, so try twice
      [0, 1500].forEach(function (delay) {
        setTimeout(function () {
          if (typeof window.__reconcileRushLines !== 'function') return;
          window.__reconcileRushLines().then(function (changed) {
            if (changed && typeof window.cart_slide_update === 'function') {
              try { window.cart_slide_update(); } catch (_) {}
            }
          });
        }, delay);
      });
      return r;
    };
    wrapped.__cCart = true;
    window.cart_update = wrapped;
  }

  function init() {
    hookCartUpdate(0);
    renderEta();
    openWarningsOnDesktop();
    restoreUndo();
    watchDrawer();
  }

  window.cCart = { renderEta: renderEta, refresh: refreshCart };

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
